import { PageLoading } from '@ant-design/pro-components';

function Loading() {
  return <PageLoading />;
}

export default Loading;
